import { render, staticRenderFns } from "./CategoryProductCount.vue?vue&type=template&id=74dfe556&scoped=true&name=product-count&"
import script from "./CategoryProductCount.vue?vue&type=script&lang=js&"
export * from "./CategoryProductCount.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProductCount.vue?vue&type=style&index=0&id=74dfe556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfe556",
  null
  
)

/* custom blocks */
import block0 from "./CategoryProductCount.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports